import { useMutation } from "react-query";
import { useIvideon } from "./useIvideon";
import { DeacceptActIProps } from "../model/schema";

export default function useDeacceptAct() {
  const { deacceptAct } = useIvideon();
  const mutation = useMutation({
    mutationFn: (data: DeacceptActIProps) => deacceptAct(data),
  });
  return { ...mutation, deacceptAct: mutation.mutateAsync };
}
